import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Academics() { 
  useEffect(() => {
    document.title = 'Academics -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Academics</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Academics</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                   <p>Mercy Memorial School is a co-educational, minority institution affiliated with the Council for the Indian School Certificate Examinations (CISCE), New Delhi. The school follows the curriculum designed by CISCE for the ICSE and ISC Examinations. For ISC, the school offers both Science and Commerce streams.</p>
                    <p><b>The school places emphasis on:   </b></p>
                     
               </div>
               <div className="col-lg-6">
                  <ul class="mainlist">
                  <li> Child-Centred Approach </li>
                  <li> Innovative Teaching Methods </li>
                  <li> Imbibing Value-Based Education </li>
                  <li> Integration of Theory and Practical Learning </li>
                  <li> Social and Emotional Development </li>
                  <li> Promoting Competitive Learning </li>
                  <li> Honing Talents and Communication Skills </li>
                  </ul>
                  </div>
                  <div className="col-lg-6">
                  <ul class="mainlist">
                  
                  <li> Reinforcing Assertiveness and Problem-Solving </li>
                  <li> Creating Environmentally Conscious Individuals </li>
                  <li> Skilled Pedagogy </li>
                  <li> Collaborative Learning and Democratic Participation </li>
                  <li> Leveraging Technology for Enhanced Learning (Emphasizing the use of digital tools and resources to support teaching and learning) </li>
                  <li> Fostering Creativity and Critical Thinking </li>
                  </ul>
                  </div>
                  <div className="col-lg-12">
                     <p>In addition to an active academic approach, we also focus on:</p>
                  </div>
                  <div className="col-lg-6">
                  <ul class="mainlist">
                  <li> Discipline</li>
                  <li> Honesty </li>
                  <li> Punctuality </li> 
                  </ul>
                  </div>
                  <div className="col-lg-6">
                  <ul class="mainlist"> 
                  <li> Sincerity </li>
                  <li> Empathy </li>
                  <li> Moral and Ethical Development </li>
                  </ul>
                  </div>
                  <div className="col-lg-12">
                  <p><b>Extracurricular Activities: </b></p>
                  <p> We also believe in the importance of extracurricular activities to foster well-rounded development. From sports to arts and cultural activities, MMS provides a platform for students to explore their passions and talents outside the classroom. These activities are designed to build confidence, teamwork, and leadership skills.</p>
                  
                  <p><b>Personalized Learning:</b></p>
                   <p> We strive to meet the diverse learning needs of our students through personalized learning strategies. This ensures that every student receives the attention and support they need to succeed academically and personally. </p>
                   <p><b>Key Additions:</b></p>
                   <p><b>1. Leveraging Technology for Enhanced Learning </b> – Mentioning technology in education highlights the modern approach to learning and shows that the school adapts to current educational trends. </p> <p><b>2. Fostering Creativity and Critical Thinking </b> – This emphasizes skills that are crucial in today’s world, showcasing the school’s commitment to shaping independent thinkers. </p> <p><b>3. Extracurricular Activities </b> – Including extracurricular activities paints a more well – rounded picture of the school’s approach, highlighting opportunities for growth outside academics. </p> <p><b>4. Personalized Learning </b> – this addition emphasizes the school’s adaptability and its focus on the unique learning needs of each student. <br/> These additions create a more complete view of the school’s academic philosophy and a holistic approach to student development. </p>
                 
                   </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Academics;
